import React from "react";

interface CommentEmptyStateProps {
  title: string;
  message: string;
}

const CommentEmptyState: React.FC<CommentEmptyStateProps> = ({ title, message }) => {
  return (
    <div className="comment-explorer-empty-state">
      <div className="comment-explorer-empty-icon">💬</div>
      <h3>{title}</h3>
      <p>{message}</p>
    </div>
  );
};

export default CommentEmptyState;
